import React from 'react';
import { useQuery } from '@apollo/client';

import CancellationInfoForm from '../../../../components/siteadmin/UpdateCancellationInfo/CancellationInfoForm';
import Loader from '../../../../components/Loader/Loader';

import { getCancellationInfo } from '../../../../lib/graphql';


function EditCancellationInfo() {

  const { data, loading } = useQuery(getCancellationInfo, {
    fetchPolicy: 'network-only',
    ssr: false
  })

  if (loading) {
    return <Loader type={"text"} />;
  }
  const results = data?.getCancellationInfo?.results || [];
  const result = results.length > 0 ? results[0] : {};
  let dynamicCancellationInfo = [];
  if (result?.dynamicCancellationInfo && result?.dynamicCancellationInfo?.length > 0) {
    result.dynamicCancellationInfo.map(item => {
      dynamicCancellationInfo.push({
        language: item.language,
        description: item.description
      })
    });
  } else {
    dynamicCancellationInfo = [{
      language: 'en',
      description: result.description
    }];
  }

  const initialValues = {
    id: result.id,
    dynamicCancellationInfo
  };
  return (
    <div>
      <CancellationInfoForm initialValues={initialValues}/>
    </div>
  )
}

export default EditCancellationInfo